import { Moment } from 'moment-timezone'
import { FullMeetingFragment, MeetingType } from '../../../../../types'

export const disableCurrent = (current: Moment | null, now: Moment, meetingDate: Moment | undefined): boolean => {
  if (!current || !meetingDate) {
    return true
  }

  if (current.isSame(now, 'day')) {
    return false
  }

  if (current.isBefore(meetingDate, 'day') || current.isAfter(now, 'day')) {
    return true
  }

  return false
}

export function isAppraisalUpdate(meeting: FullMeetingFragment): boolean {
  return meeting.type === MeetingType.AppraisalUpdate
}
